import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import AdminLoginModal from './AdminLoginModal';
import SupportAssistant from './shared/SupportAssistant/SupportAssistant';

interface AdminPrivateRouteProps {
  children: React.ReactElement;
}

const AdminPrivateRoute: React.FC<AdminPrivateRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAdminAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = React.useState(false);

  // Si no está autenticado, mostrar modal de login
  useEffect(() => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <>
        <AdminLoginModal isOpen={showLoginModal} onClose={() => navigate('/')} />
      </>
    );
  }

  return (
    <>
      {children}
      <SupportAssistant />
    </>
  );
};

export default AdminPrivateRoute;
